import { LazyLoadImage } from 'react-lazy-load-image-component';
import { VISA, AddCircle, BankLogo } from '../assets/icons';
import { Images } from '../config/images';
import './getBankLogo.scss';

export const getBankLogo = (bankName, className = 'mr-8') => {
  switch (bankName) {
    case 'Bank of America':
    case 'Wells Fargo':
    case 'Citibank Online':
    case 'Chase':
    case 'USAA':
    case 'TD Bank':
    case 'Regions Bank':
    case 'Navy Federal Credit Union':
    case 'Charles Schwab':
    case 'Fidelity':
    case 'Citizens Bank':
    case 'Huntington Bank':
      return <BankLogo verticalAlign='-10px' className={className} />;
    case 'VISA':
      return <VISA verticalAlign='-10px' className='mr-8' />;
    case 'Add new':
      return <AddCircle verticalAlign='-6px' className='mr-8' />;
    case 'Wallet':
    case 'DWOLLA':
    case 'Dwolla':
      return <LazyLoadImage className='realbricks-logo mr-8' src={Images.realBricksLogo} alt='A girl holding moneybag' />;
    default:
      return <BankLogo verticalAlign='-10px' className={className} />;
  }
};
